export default {

    state: {
      modeloMinuta: null
    },
  
    mutations: {
        setModeloMinuta(state, payload) {
          state.modeloMinuta = payload;
        }
    },
  
    getters: {
      getModeloMinuta(state) {
        return state.modeloMinuta;
      }
    },

    actions: {
        setModeloMinuta({commit}, modeloMinuta){
          commit('setModeloMinuta', modeloMinuta);
        }
    },
    
  }